(function (angular) {
    'use strict';

    angular.module('chat2')

        /**
         *
         */
        .factory('teamSettingsService',
            ['$http', '$q', 'portalConfig',
                function ($http, $q, portalConfig) {

                    var urlBase = portalConfig.urlBase;
                    var chatConfigBase = portalConfig.urlBase;
                    //urlBase = 'http://localhost:8001';
                    //chatConfigBase = 'http://localhost:8003'
                    var fac = {
                        getTeams: getTeams,
                        getTeam: getTeam,
                        getChatConfig: getChatConfig,
                        createTeam: createTeam,
                        updateTeam: updateTeam,
                        updateChatConfigFb: updateChatConfigFb,
                        updateChatConfigSms: updateChatConfigSms,
                        updateAppMessagingConfig: updateAppMessagingConfig,
                        updateEmailConfig: updateEmailConfig,
                        updateWhatsAppConfig: updateWhatsAppConfig,
                        updateSettings: updateSettings,
                        deleteTeam: deleteTeam,
                        deleteConfigFb: deleteConfigFb,
                        deleteConfigSms: deleteConfigSms,
                        deleteAppMessagingConfig: deleteAppMessagingConfig,
                        deleteEmailConfig: deleteEmailConfig,
                        deleteSettings: deleteSettings,
                        createTeamMember: createTeamMember,
                        deleteTeamMember: deleteTeamMember,
                        deleteConfigTwitter: deleteConfigTwitter,
                        deleteWhatsAppConfig: deleteWhatsAppConfig,
                        updateChatConfigTwitter: updateChatConfigTwitter,
                        deleteRcsConfig: deleteRcsConfig,
                        updateRcsConfig: updateRcsConfig
                    };

                    return fac;

                    /**
                     * GET "/apispaces/{id}/teams"
                     * @param {string} id - the api space Id
                     */
                    function getTeams(id) {

                        return $http.get(urlBase + "/apispaces/" + id + "/teams")
                            .then(getTeamsComplete)
                            .catch(getTeamsFailed);

                        function getTeamsComplete(response) {
                            return response.data;
                        }

                        function getTeamsFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    /**
                     * GET "/apispaces/{id}/teams/{teamId}"
                     * @param {string} id - the api space Id
                     * @param {string} teamId - the team Id
                     */
                    function getTeam(id, teamId) {

                        return $http.get(urlBase + "/apispaces/" + id + "/teams/" + teamId)
                            .then(getTeamComplete)
                            .catch(getTeamFailed);

                        function getTeamComplete(response) {
                            return response.data;
                        }

                        function getTeamFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    /**
                     * GET "/apispaces/{apiSpaceId}/chat/config"
                     * @param {string} apiSpaceId - the api space Id
                     */
                    function getChatConfig(id) {

                        return $http.get(chatConfigBase + "/apispaces/" + id + "/chat/config")
                            .then(getChatConfigComplete)
                            .catch(getChatConfigFailed);

                        function getChatConfigComplete(response) {
                            return response.data;
                        }

                        function getChatConfigFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    /**
                     * POST "/apispaces/{id}/teams/"
                     * @param {string} id - the api space Id
                     * @param {string} teamDetails - Detail of the team to create
                     */
                    function createTeam(id, teamDetails) {

                        return $http.post(urlBase + "/apispaces/" + id + "/teams", teamDetails)
                            .then(createTeamComplete)
                            .catch(createTeamFailed);

                        function createTeamComplete(response) {
                            return response.data;
                        }

                        function createTeamFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }
                    /**
                     * PUT "/apispaces/{id}/teams/{teamId}"
                     * @param {string} id - the api space Id
                     * @param {string} teamId - the team Id
                     * @param {string} updateData - data to update
                     */
                    function updateTeam(id, teamId, updateData) {

                        return $http.put(urlBase + "/apispaces/" + id + "/teams/" + teamId, updateData)
                            .then(updateTeamComplete)
                            .catch(updateTeamFailed);

                        function updateTeamComplete(response) {
                            return response.data;
                        }

                        function updateTeamFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }
                    /**
                     * PUT "/apispaces/{id}/chat/config/teams/{teamId}/sms"
                     * @param {string} id - the api space Id
                     * @param {string} teamId - the team Id
                     * @param {string} updateData - data to update
                     */
                    function updateChatConfigSms(id, teamId, updateData) {

                        return $http.put(chatConfigBase + "/apispaces/" + id + "/chat/config/teams/" + teamId + "/sms", updateData)
                            .then(updateChatConfigSmsComplete)
                            .catch(updateChatConfigSmsFailed);

                        function updateChatConfigSmsComplete(response) {
                            return response.data;
                        }

                        function updateChatConfigSmsFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }
                    /**
                     * PUT "/apispaces/{id}/chat/config/teams/{teamId}/fbMessenger"
                     * * @param {string} id - the api space Id
                     * * @param {string} teamId - the team Id
                     * * @param {string} updateData - data to update
                     * */
                    function updateChatConfigFb(id, teamId, updateData) {

                        return $http.put(chatConfigBase + "/apispaces/" + id + "/chat/config/teams/" + teamId + "/fbMessenger", updateData)
                            .then(updateChatConfigFbComplete)
                            .catch(updateChatConfigFbFailed);

                        function updateChatConfigFbComplete(response) {
                            return response.data;
                        }

                        function updateChatConfigFbFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    function updateChatConfigTwitter(id, teamId, data) {

                        return $http.put(chatConfigBase + "/apispaces/" + id + "/chat/config/teams/" + teamId + "/twitter", data)
                            .then(function (response) {
                                return response.data;
                            })
                            .catch(function (error) {
                                console.error(JSON.stringify(error));
                                return $q.reject(error);
                            });
                    }

                    /**
                     * PUT "/apispaces/{apiSpaceId}/chat/config/teams/{teamId}/appMessaging"
                    * * @param {string} id - the api space Id
                    * * @param {string} teamId - the team Id
                    * * @param {string} updateData - data to update
                    * */

                    function updateAppMessagingConfig(id, teamId, updateData) {

                        return $http.put(chatConfigBase + "/apispaces/" + id + "/chat/config/teams/" + teamId + "/appMessaging", updateData)
                            .then(updateAppMessagingConfigComplete)
                            .catch(updateAppMessagingConfigFailed);

                        function updateAppMessagingConfigComplete(response) {
                            return response.data;
                        }

                        function updateAppMessagingConfigFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    /**
                     * PUT "/apispaces/{apiSpaceId}/chat/config/teams/{teamId}/email"
                    * * @param {string} id - the api space Id
                    * * @param {string} teamId - the team Id
                    * * @param {string} updateData - data to update
                    * */

                    function updateEmailConfig(id, teamId, updateData) {

                        return $http.put(chatConfigBase + "/apispaces/" + id + "/chat/config/teams/" + teamId + "/email", updateData)
                            .then(updateEmailConfigComplete)
                            .catch(updateEmailConfigFailed);

                        function updateEmailConfigComplete(response) {
                            return response.data;
                        }

                        function updateEmailConfigFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    /**
                     * PUT "/apispaces/{apiSpaceId}/chat/config/teams/{teamId}/whatsapp"
                    * * @param {string} id - the api space Id
                    * * @param {string} teamId - the team Id
                    * * @param {string} updateData - data to update
                    * */

                    function updateWhatsAppConfig(id, teamId, updateData) {

                        return $http.put(chatConfigBase + "/apispaces/" + id + "/chat/config/teams/" + teamId + "/whatsapp", updateData)
                            .then(updateWhatsAppConfigComplete)
                            .catch(updateWhatsAppConfigFailed);

                        function updateWhatsAppConfigComplete(response) {
                            return response.data;
                        }

                        function updateWhatsAppConfigFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    /**
                         * PUT "/apispaces/{apiSpaceId}/chat/config/teams/{teamId}/rcs"
                        * * @param {string} id - the api space Id
                        * * @param {string} teamId - the team Id
                        * * @param {string} updateData - data to update
                        * */

                    function updateRcsConfig(id, teamId, updateData) {

                        return $http.put(chatConfigBase + "/apispaces/" + id + "/chat/config/teams/" + teamId + "/rcs", updateData)
                            .then(updateRcsConfigComplete)
                            .catch(updateRcsConfigFailed);

                        function updateRcsConfigComplete(response) {
                            return response.data;
                        }

                        function updateRcsConfigFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    /**
                    * PUT "/apispaces/{apiSpaceId}/chat/config/teams/{teamId}/settings"
                    * * @param {string} id - the api space Id
                    * * @param {string} teamId - the team Id
                    * * @param {string} updateData - data to update
                    * */

                    function updateSettings(id, teamId, updateData) {

                        return $http.put(chatConfigBase + "/apispaces/" + id + "/chat/config/teams/" + teamId + "/settings", updateData)
                            .then(updateSettingsComplete)
                            .catch(updateSettingsFailed);

                        function updateSettingsComplete(response) {
                            return response.data;
                        }

                        function updateSettingsFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }


                    /**
                     * DELETE "/apispaces/{id}/teams/{teamId}"
                     * @param {string} id - the api space Id
                     * @param {string} teamId - the team Id
                     */
                    function deleteTeam(id, teamId) {

                        return $http.delete(urlBase + "/apispaces/" + id + "/teams/" + teamId)
                            .then(deleteTeamComplete)
                            .catch(deleteTeamFailed);

                        function deleteTeamComplete(response) {
                            return response.data;
                        }

                        function deleteTeamFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    /**
                     * * DELETE "/apispaces/{apiSpaceId}/chat/config/teams/{teamId}/fbMessenger"
                     * * @param {string} id - the api space Id
                     * * @param {string} teamId - the team Id
                     * */
                    function deleteConfigSms(id, teamId) {

                        return $http.delete(chatConfigBase + "/apispaces/" + id + "/chat/config/teams/" + teamId + "/sms")
                            .then(deleteChatConfigSmsComplete)
                            .catch(deleteChatConfigSmsFailed);

                        function deleteChatConfigSmsComplete(response) {
                            return response.data;
                        }

                        function deleteChatConfigSmsFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    /**
                        * * DELETE "/apispaces/{apiSpaceId}/chat/config/teams/{teamId}/fbMessenger"
                        * * @param {string} id - the api space Id
                        * * @param {string} teamId - the team Id
                        * */
                    function deleteConfigFb(id, teamId) {

                        return $http.delete(chatConfigBase + "/apispaces/" + id + "/chat/config/teams/" + teamId + "/fbMessenger")
                            .then(deleteChatConfigFbComplete)
                            .catch(deleteChatConfigFbFailed);

                        function deleteChatConfigFbComplete(response) {
                            return response.data;
                        }

                        function deleteChatConfigFbFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    function deleteConfigTwitter(id, teamId) {

                        return $http.delete(chatConfigBase + "/apispaces/" + id + "/chat/config/teams/" + teamId + "/twitter")
                            .then(function (response) {
                                return response.data;
                            })
                            .catch(function (error) {
                                console.error(JSON.stringify(error));
                                return $q.reject(error);
                            });
                    }

                    /**
                    * * DELETE "/apispaces/{apiSpaceId}/chat/config/teams/{teamId}/appMessaging"
                    * * @param {string} id - the api space Id
                    * * @param {string} teamId - the team Id
                    * */
                    function deleteAppMessagingConfig(id, teamId) {

                        return $http.delete(chatConfigBase + "/apispaces/" + id + "/chat/config/teams/" + teamId + "/appMessaging")
                            .then(deleteAppMessagingConfigComplete)
                            .catch(deleteAppMessagingConfigFailed);

                        function deleteAppMessagingConfigComplete(response) {
                            return response.data;
                        }

                        function deleteAppMessagingConfigFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }


                    /**
                    * * DELETE "/apispaces/{apiSpaceId}/chat/config/teams/{teamId}/email"
                    * * @param {string} id - the api space Id
                    * * @param {string} teamId - the team Id
                    * */
                    function deleteEmailConfig(id, teamId) {

                        return $http.delete(chatConfigBase + "/apispaces/" + id + "/chat/config/teams/" + teamId + "/email")
                            .then(deleteEmailConfigComplete)
                            .catch(deleteEmailConfigFailed);

                        function deleteEmailConfigComplete(response) {
                            return response.data;
                        }

                        function deleteEmailConfigFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    /**
                    * * DELETE "/apispaces/{apiSpaceId}/chat/config/teams/{teamId}/whatsapp"
                    * * @param {string} id - the api space Id
                    * * @param {string} teamId - the team Id
                    * */
                    function deleteWhatsAppConfig(id, teamId) {

                        return $http.delete(chatConfigBase + "/apispaces/" + id + "/chat/config/teams/" + teamId + "/whatsapp")
                            .then(deleteWhatsAppConfigComplete)
                            .catch(deleteWhatsAppConfigFailed);

                        function deleteWhatsAppConfigComplete(response) {
                            return response.data;
                        }

                        function deleteWhatsAppConfigFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    /**
                    * * DELETE "/apispaces/{apiSpaceId}/chat/config/teams/{teamId}/rcs"
                    * * @param {string} id - the api space Id
                    * * @param {string} teamId - the team Id
                    * */
                    function deleteRcsConfig(id, teamId) {

                        return $http.delete(chatConfigBase + "/apispaces/" + id + "/chat/config/teams/" + teamId + "/rcs")
                            .then(deleteRcsConfigComplete)
                            .catch(deleteRcsConfigFailed);

                        function deleteRcsConfigComplete(response) {
                            return response.data;
                        }

                        function deleteRcsConfigFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    /**
                     * * DELETE "/apispaces/{apiSpaceId}/chat/config/teams/{teamId}/settings"
                     * * @param {string} id - the api space Id
                     * * @param {string} teamId - the team Id
                     * */
                    function deleteSettings(id, teamId) {

                        return $http.delete(chatConfigBase + "/apispaces/" + id + "/chat/config/teams/" + teamId + "/settings")
                            .then(deleteSettingsComplete)
                            .catch(deleteSettingsFailed);

                        function deleteSettingsComplete(response) {
                            return response.data;
                        }

                        function deleteSettingsFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    /**
                     * POST "/apispaces/{id}/teams/{teamId}/members"
                     * @param {string} id - the api space Id
                     * @param {string} memberData - Detail of the member to add to the team
                     */
                    function createTeamMember(id, teamId, memberData) {

                        return $http.post(urlBase + "/apispaces/" + id + "/teams/" + teamId + "/members", memberData)
                            .then(createTeamMemberComplete)
                            .catch(createTeamMemberFailed);

                        function createTeamMemberComplete(response) {
                            return response.data;
                        }

                        function createTeamMemberFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    /**
                     * DELETE "/apispaces/{id}/teams/{teamId}/members/{memberId}"
                     * @param {string} id - the api space Id
                     * @param {string} teamId - the team Id
                     * @param {string} memberId - The Member id
                     */
                    function deleteTeamMember(id, teamId, memberId) {

                        return $http.delete(urlBase + "/apispaces/" + id + "/teams/" + teamId + "/members/" + memberId)
                            .then(deleteTeamMemberComplete)
                            .catch(deleteTeamMemberFailed);

                        function deleteTeamMemberComplete(response) {
                            return response.data;
                        }

                        function deleteTeamMemberFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }
                }]);
})(window.angular);
